import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeRequest, dispatchAction, displayMessage } from 'actions';
import {
  FETCH_ADMIN_PRODUCTS,
  CLEAR_SELECTED_PRODUCTS,
  DELETE_ADMIN_PRODUCT,
  FETCH_FOCUS_AREAS,
  FETCH_ALL_SELLERS_LIST,
} from 'actions/actionTypes';
import queryString from 'query-string';
import async from 'async';
import PaginationBox from 'shared/PaginationBox';
import RemoveModalDialog from 'shared/RemoveModalDialog';
import AdminProductListTable from 'dashboard/products/AdminProductListTable';
import AdminProductSearchBox from 'dashboard/products/AdminProductSearchBox';
import AdminProductActionsBox from 'dashboard/products/AdminProductActionsBox';
import AdminPalletProductListTable from 'dashboard/pallets/AdminPalletProductListTable';
import InventoryProjectProductListTable from 'dashboard/inventoryProjects/InventoryProjectProductListTable';
import { fetchSettings } from 'shared/sharedMethods';
import config from '../../../config';

class AdminProductPage extends Component {
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
    };
  }

  constructor(props, context) {
    super(props, context);
    var queryParams = queryString.parse(this.props.location.search);
    this.state = {
      perPage: config.table.numberPerPage,
      currentPage: queryParams.page ? parseInt(queryParams.page) - 1 : 0,
      searchType:'onSale',
      dataToDisplay: [],
      selectAllProducts: false,
    };
    this.ProductsSettingsData = {
      FeatureFlags:{}
    }
    fetchSettings.call(this,'ProductsSettings').then(result => {
      this.ProductsSettingsData = result;
    });
  }

  componentWillMount() {
    var self = this;
    if (_.size(self.props.focusAreas.data) == 0) {
      var methodData = {
        success_event: FETCH_FOCUS_AREAS,
        endpoint: '/focus-areas',
        not_display_success_message: true,
      };
      this.props.makeRequest({}, methodData).catch((err) => {});
    }
    if (_.size(self.props.allSellersList.data) == 0) {
      var methodData = {
        success_event: FETCH_ALL_SELLERS_LIST,
        endpoint: '/sellers',
        not_display_success_message: true,
      };
      this.props
        .makeRequest(
          { sortBy: 'DisplayName:1', all: true, include: ['DisplayName', 'InventoryOwnership'] },
          methodData
        )
        .catch((err) => {});
    }
    if (this.props.location.query.InventoryProjectID) {
      this.getInventoryProjectRecord();
    }
  }
  getInventoryProjectRecord() {
    this.props
      .makeRequest(
        { recordIDs: [this.props.location.query.InventoryProjectID] },
        {
          endpoint: '/inventory_projects',
          timeout: 25000,
          not_display_error_message: true,
        }
      )
      .then(
        function (res) {
          if (_.get(res.data, 'data.0._id')) {
            this.setState({ InventoryProjectRecord: res.data.data[0] });
          }
        }.bind(this)
      )
      .catch((err) => {});
  }
  toggleAllProductsSelection(value) {
    if (value) {
      this.setState({ selectAllProducts: true });
    } else {
      this.setState({ selectAllProducts: false });
    }
  }

  onSortChange(field, sortOrder) {
    console.log('field', field);
    this.setState({ sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1) }, function () {
      this.refs.pagination.resetPagination();
      this.search();
    });
  }

  search(params = {}) {
    if (this.state.pending) {
      return this.props.displayMessage({
        messageType: 'warning',
        messageCode: 'Please wait till search request is completed',
      });
    }
    this.setState({ pending: true });
    var self = this;
    if (_.isUndefined(params.doNotClearSelectedProducts) && _.isUndefined(params.page)) {
      /* do not clear selected transactions when only pagination is changed */
      this.props.dispatchAction({}, CLEAR_SELECTED_PRODUCTS);
    }
    if (_.size(_.get(this.refs.actionsBox, 'state.additionalDataFields', []))) {
      this.refs.actionsBox.fetchAdditionalData({});
    }
    var { queryParams } = this.searchBox.getSearchParams();
    console.log('queryParams', queryParams);

    if (params.page == 1) {
      params.page = undefined;
    }
    _.extend(queryParams, params);
    if (!_.isUndefined(params.include)) {
      queryParams.include = params.include;
    }
    if (!_.isUndefined(params.all)) {
      queryParams.all = true;
    }
    if (this.state.sortBy) {
      queryParams.sortBy = this.state.sortBy;
      queryParams.sortBySecondary = '_id:-1';
      /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
      if (_.includes(queryParams.sortBy, 'SKU')) {
        var FieldAndSortOption = queryParams.sortBy.split(':');
        queryParams.sortBy = 'SellerID.SellerNumber:' + FieldAndSortOption[1];
        queryParams.sortBySecondary = 'PickupID.SellerPickupNumber:' + FieldAndSortOption[1];
        queryParams.sortByThird = 'ProductNumber:' + FieldAndSortOption[1];
      }
    }
    //  queryParams.addFields = ['FirstSaleTransaction','SellerAndPickupNumber' ]
    if (queryParams.InventoryProjectID) {
      queryParams.addFields = ['InventoryProjectData', 'SellerAndPickupNumber'];
    } else {
      queryParams.addFields = ['FirstSaleTransaction', 'SellerAndPickupNumber', 'SoldQuantity'];
    }
    //  queryParams.includeSaleTransactionsInTotalCount = true
    queryParams.lookup = ['CreatedByUserID', 'SellerID', 'Pickup'];
    if (queryParams.PalletID || queryParams.palletStatuses) {
      queryParams.lookup.push('PalletID');
      queryParams.addFields.push('CreatedInShopifyAt');
    }
    if (queryParams.InventoryProjectID) {
      queryParams.lookup.push('InventoryProjectID');
    }

    if (
      queryParams.all &&
      !_.isUndefined(params.page) &&
      this.props.adminProducts.data.length > 300
    ) {
      var from = (queryParams.page - 1) * queryParams.perPage;
      var to = from + parseInt(queryParams.perPage);
      this.setState({
        dataToDisplay: this.props.adminProducts.data.slice(from, to),
        pending: false,
      });
      return;
    }
    var methodData = {
      endpoint: '/products',
      not_display_success_message: true,
    };
    if (_.isUndefined(params.include)) {
      methodData['success_event'] = FETCH_ADMIN_PRODUCTS;
    }

    var stringified = queryString.stringify(
      _.omit(queryParams, [
        'include',
        'ProductVariationsToMatch',
        'productIDs',
        'productFinalized',
        'ProductVariationsToExclude',
        'sortBy',
        'sortByThird',
        'sortBySecondary',
        'addFields',
        'PickupID',
        'CreatedByUserID',
        'lookup',
        'all',
        'sortBySecondary',
      ])
    );
    delete queryParams.ServiceID; /* PickupID is used instead of ServiceID*/

    if (_.get(queryParams, 'productIDs', []).length) {
      queryParams.ShopifyProductIDs = _.get(queryParams, 'productIDs', []);
      stringified += '&productIDs=' + _.get(queryParams, 'productIDs', []).join(',');
    }
    delete queryParams.productIDs;
    this.context.router.push('/admin/products?' + stringified);
    //   }.bind(this))

    return this.props
      .makeRequest(queryParams, methodData)
      .then(function (res) {
        var dataToDisplay = [];
        if (_.isUndefined(params.include)) {
          if (queryParams.all && res.data.total > 300) {
            dataToDisplay = res.data.data.slice(0, queryParams.perPage);
          }
        }
        self.setState({ dataToDisplay: dataToDisplay, pending: false });
        if (self.refs.pagination && _.isUndefined(queryParams.page)) {
          self.refs.pagination.resetPagination();
        }
        return res;
      })
      .catch((err) => {
        self.setState({ pending: false });
      });
  }
  getAggregatedData(params) {
    return new Promise((resolve, reject) => {
      var self = this;
      var functionsToCall = {};
      _.forEach(params.additionalDataFields, function (field, index) {
        console.log('field, index', field, index);

        functionsToCall[field.value] = function (done) {
          var { queryParams } = self.searchBox.getSearchParams();
          queryParams.groupBy = field.value;
          queryParams.all = true;
          //   queryParams.lookup = ['CreatedByUserID','SellerID','Pickup', 'Transactions']
          queryParams.addFields = params.totalDataFields;
          var methodData = {
            endpoint: '/products',
            not_display_success_message: true,
          };
          delete queryParams.ServiceID;
          return self.props
            .makeRequest(queryParams, methodData)
            .then(function (res) {
              console.log('res.data', res.data);
              done(null, res.data);
            })
            .catch((err) => {
              console.log('error', err);
              done(err);
            });
        };
      });
      async.parallel(functionsToCall, function (err, results) {
        console.log('err', err);
        if (err) {
          return reject();
        }
        console.log('results', results);
        resolve(results);
      });
    });
  }
  showRemoveDialog(row) {
    this.setState({ removeRecordModalVisible: true, currentRecord: row });
  }

  deleteRecord() {
    this.setState({ removeRecordModalVisible: false });
    var methodData = {
      type: 'delete',
      endpoint: '/products/' + encodeURIComponent(this.state.currentRecord._id),
      messageData: { '#1#': 'Product' },
      messageCode: 'recordDeleted',
      success_event: DELETE_ADMIN_PRODUCT,
      success_event_data: { productID: this.state.currentRecord._id },
    };

    this.props
      .makeRequest({}, methodData)
      .then((res) => {
        this.setState({ currentRecord: {} });
        this.search();
      })
      .catch((err) => {
        this.setState({ currentRecord: {} });
        console.log('e', err);
      });
  }
  render() {
    return (
      <div>
        {_.isUndefined(this.props.location.query.PalletID) &&
          config.checkAccessRights.call(this, { resources: ['products_edit'] }) && (
            <AdminProductActionsBox
              ref={'actionsBox'}
              searchBox={this.searchBox}
              search={this.search.bind(this)}
              getAggregatedData={this.getAggregatedData.bind(this)}
              {...this.props}
            ></AdminProductActionsBox>
          )}
        <AdminProductSearchBox
          ref={(searchBox) => {
            if (searchBox && !this.searchBox) {
              this.searchBox = searchBox;
              if (_.size(_.get(this.props.location.query, 'recordIDs', []))) {
                /* by default search only if recordIDs are passed*/
                this.search({ page: this.state.currentPage + 1 });
              }
            }
          }}
          ProductsSettingsData={this.ProductsSettingsData}
          pending={this.state.pending}
          InventoryProjectRecord={_.get(this.state, 'InventoryProjectRecord')}
          search={this.search.bind(this)}
          selectAllProducts={this.state.selectAllProducts}
          toggleAllProductsSelection={this.toggleAllProductsSelection.bind(this)}
          {...this.props}
        ></AdminProductSearchBox>

        {this.props.adminProducts.fetched && (
          <div>
            {this.props.adminProducts.total == 0 ? (
              <div className="messageBox">
                {config.clientMessages.noRecordsFoundForCriteria.replace('#1#', 'Products')}
              </div>
            ) : (
              <div className="top20">
                {this.props.location.query.PalletID ||
                this.props.location.query.InventoryProjectID ? (
                  <div>
                    {this.props.location.query.PalletID && (
                      <AdminPalletProductListTable
                        onSortChange={this.onSortChange.bind(this)}
                        search={this.search.bind(this)}
                        {...this.props}
                      ></AdminPalletProductListTable>
                    )}
                    {this.props.location.query.InventoryProjectID &&
                      _.get(this.state, 'InventoryProjectRecord._id') && (
                        <InventoryProjectProductListTable
                          onSortChange={this.onSortChange.bind(this)}
                          InventoryProjectRecord={_.get(this.state, 'InventoryProjectRecord')}
                          search={this.search.bind(this)}
                          {...this.props}
                        ></InventoryProjectProductListTable>
                      )}
                  </div>
                ) : (
                  <AdminProductListTable
                    data={
                      this.state.dataToDisplay.length > 0
                        ? this.state.dataToDisplay
                        : this.props.adminProducts.data
                    }
                    currentPage={
                      _.isUndefined(queryString.parse(this.props.location.search).page)
                        ? 0
                        : parseInt(queryString.parse(this.props.location.search).page) - 1
                    }
                    onSortChange={this.onSortChange.bind(this)}
                    showRemoveDialog={this.showRemoveDialog.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props}
                  ></AdminProductListTable>
                )}

                <PaginationBox
                  ref={'pagination'}
                  currentPage={this.state.currentPage}
                  perPage={
                    this.props.adminProducts.total == _.size(this.props.adminProducts.data) &&
                    _.size(this.state.dataToDisplay) == 0
                      ? undefined
                      : this.searchBox
                      ? this.searchBox.state.filterOptions.perPage
                      : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)
                  }
                  total={this.props.adminProducts.total}
                  search={this.search.bind(this)}
                ></PaginationBox>
              </div>
            )}
          </div>
        )}
        <RemoveModalDialog
          show={this.state.removeRecordModalVisible}
          removeRecord={(e) => this.deleteRecord()}
          closeModal={(e) =>
            this.setState({ currentItemID: false, removeRecordModalVisible: false })
          }
        ></RemoveModalDialog>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    //seller: getSeller(state, props.params.id),
    userReducer: state.userReducer,
    appData: state.appData,
    adminProducts: state.adminProducts,
    focusAreas: state.focusAreas,
    allSellersList: state.allSellersList,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ makeRequest, dispatchAction, displayMessage }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(hot(AdminProductPage));
